module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/739LOu/tc-custom/9798886936841.jpg?1737196545586",
      "alt": "This image is the cover for the book Mind of a Mixed State"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Mind of a Mixed State\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Have you or anyone you’ve known suffered through the depth of depression or mania? What about both at the same time? "), _c('em', [_vm._v("Mind of a Mixed State")]), _vm._v(" follows the thoughts and emotional tribulations of a young woman riding the waves of a severe Bipolar mixed episode with psychotic features. Take a journey through the mind of someone struggling to find their voice as they navigate the nation-wide issues that plagues many of us: mental illness.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Ciara Platt\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }), _c('p', {
    staticStyle: {
      "margin-top": "0cm",
      "margin-right": "0cm",
      "margin-bottom": "0cm",
      "margin-left": "0cm",
      "font-size": "15px",
      "font-family": "\"Calibri\",sans-serif",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "\"Times New Roman\",serif"
    }
  }, [_vm._v("Ciara Platt is a young woman from North Idaho. Ever since she was a child, she’s found solace in writing and sharing her thoughts. In 2022, she was hospitalized for schizoaffective disorder, bipolar type. She has since decided to share her journey with others in hopes that it would help normalize mental health and help others feel less alone. She is happily married with two small babies and finds great comfort in being a mom. She hopes to continue to use her voice as a tool to help end the stigma surrounding on mental health and encourages those around her to do the same.")])]), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0